module.exports = __webpack_public_path__ + "static/media/bifrost_knot_64.f3a0692c.png";